var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE17D"
    },
    d: "M248.768,1.654L19.499,112.336c-2.875,1.388-4.701,4.298-4.701,7.49v272.348 c0,3.192,1.827,6.102,4.701,7.49l229.269,110.682c4.569,2.206,9.895,2.206,14.464,0l229.269-110.682 c2.875-1.388,4.701-4.298,4.701-7.49V119.826c0-3.192-1.827-6.102-4.701-7.49L263.232,1.654 C258.663-0.551,253.337-0.551,248.768,1.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC350"
    },
    d: "M16.181,115.273c-0.874,1.331-1.383,2.898-1.383,4.553v272.348c0,3.192,1.827,6.102,4.701,7.49 l229.269,110.681c2.284,1.103,4.758,1.654,7.232,1.654V231.048L16.181,115.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD164"
    },
    d: "M495.819,115.273c0.874,1.331,1.383,2.898,1.383,4.553v272.348c0,3.192-1.827,6.102-4.701,7.49 L263.232,510.345C260.948,511.448,258.474,512,256,512V231.048L495.819,115.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE17D"
    },
    d: "M83.407,377.657c-1.21,0-2.445-0.268-3.606-0.828L44.404,359.74 c-4.142-1.998-5.872-6.969-3.874-11.103c1.99-4.134,6.977-5.856,11.103-3.874l35.397,17.09c4.142,1.998,5.872,6.969,3.874,11.103 C89.475,375.927,86.502,377.657,83.407,377.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF6D8"
    },
    d: "M115.986,356.45c-1.21,0-2.445-0.268-3.606-0.828l-67.928-32.79 c-4.134-1.998-5.872-6.969-3.874-11.103c1.99-4.126,6.985-5.856,11.103-3.874l67.927,32.79c4.134,1.998,5.872,6.969,3.874,11.103 C122.054,354.719,119.081,356.45,115.986,356.45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8087"
    },
    points: "414.549,154.373 173.887,38.11 110.447,68.86 351.649,185.303 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M351.649,185.303v90.207c0,3.066,3.205,5.078,5.967,3.745l52.232-25.215 c2.875-1.388,4.701-4.298,4.701-7.49v-92.176L351.649,185.303z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom1);
export default __webpack_public_path__ + "static/media/custom_1.6c5eab11cee42c2f1784c235cd14b8ba.svg";
export { ForwardRef as ReactComponent };